import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import _ from "lodash"
import classnames from "classnames"

import { useFirebase } from "@meddbriefer/mdb-firebase"

import { getScenarioByID } from "@meddbriefer/scenario-data"

import { useScenarioEditor } from "./ScenarioEditorContext"
import ScenarioEditorLayout from "./ScenarioEditorLayout"

const getLabel = (obj) => {
    if (!!obj.abbrLabel && "" !== obj.abbrLabel) {
        return obj.abbrLabel
    } else {
        return obj.label
    }
}

export default function CheckListCorrectness() {
    const {db} = useFirebase()
    const {scenarioId} = useParams()
    const {scenario, saveScenario, updateScenarioFld, scenarioType } = useScenarioEditor()
    const [state, setState] = useState(null) // prompt ids mapped to option ids
    const [origState, setOrigState] = useState(null) // simply so we can compare to check for changes
    const [prompts, setPrompts] = useState(null) // list of prompts and their options, not their current values
    const [hasChanges, setHasChanges] = useState(false) // used to enable/disable save btn
    const [stateUpdated, setStateUpdated] = useState(false) // if true, the value of hasChanges will be determined
    const [validationErrors, setValidationErrors] = useState(null) // prompt ids -> bool to mark which aren't answered
    const [readyToSave, setReadyToSave] = useState(false) // no validation errors present, ok to persist state


    const performValidation = () => {
        let haveErrors = false
        const errs = {}
        Object.entries(state).forEach(([key, value]) => {
            if (!value) {
                haveErrors = true
                errs[key] = true
            } else {
                errs[key] = false
            }
        })
        if (haveErrors) {
            setValidationErrors(errs)
        }
        return !haveErrors
    }

    const saveHandler = (event) => {
        if (performValidation()) {
            setReadyToSave(true)
        }
    }

    const changeHandler = (event) => {
        const {name, value} = event.target
        setState(prevState => ({...prevState, [name]: value}))
        setStateUpdated(true)
    }

    useEffect(
        () => {
            if (!prompts) {
                const tmp = scenario.checkListCorrectness
                setState(tmp)
                setOrigState(tmp)
                const tmp2 = []
                const valErrors = {}
                Object.entries(tmp).forEach(([key, value]) => {
                    tmp2.push(scenarioType.getDecisionWithOptions(key))
                    valErrors[key] = false
                })
                setPrompts(tmp2)
                setValidationErrors(valErrors)
            }
        }, [scenarioId, prompts, scenario.checkListCorrectness, scenarioType]
    )

    useEffect(
        () => {
            if (stateUpdated) {
                // guard to prevent endless loop
                setStateUpdated(false)
                if (! _.isEqual(state, origState)) {
                    setHasChanges(true)
                }
            }
        }, [stateUpdated, state, origState]
    )

    useEffect(
        () => {
            if (readyToSave) {
                // prevent endless loop. particulary since this hits the db
                setReadyToSave(false)
                setHasChanges(false)
                // persist our local state to the scenario
                updateScenarioFld("checkListCorrectness", state)
                const saveToDB = async () => {
                    const scenData = {
                        ...await getScenarioByID(db, scenarioId),
                        checkListCorrectness: state
                    }
                    await saveScenario(scenData)
                }
                saveToDB()
            }
        }, [readyToSave, scenarioId, state, updateScenarioFld, saveScenario]
    )

    if (!state) {
        return (<div>Loading...</div>)
    }
    return (
        <ScenarioEditorLayout
            label="Save changes to Checklist Correctness"
            haveChanges={hasChanges}
            saveHandler={saveHandler}
        >
            <div id="checklist-options" className="info-wrapper">
                {prompts.map(prompt =>
                    <div key={prompt.id} style={{paddingBottom: "20px"}}>
                        <i>{getLabel(prompt)}</i><br/>
                        <div className={classnames("error", {hidden: !validationErrors[prompt.id]})}>
                            Please select an option
                        </div>
                        {prompt.options.map(opt =>
                            <div key={opt.id} >
                                <label>
                                    <input
                                        type="radio"
                                        name={prompt.id}
                                        value={opt.id}
                                        checked={state[prompt.id] === opt.id}
                                        onChange={changeHandler}
                                    />
                                    {getLabel(opt)}
                                </label>
                                <br/>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </ScenarioEditorLayout>
    )
}
